// extracted by mini-css-extract-plugin
export default {"constructorItem":"constructor-inner-element_constructorItem__7LF6K"};